<template>
    <ini-layout v-if="hasAccess" class="gdpr-index" :title="pageTitle" icon="gdpr" no-return-page>
        <template slot="summary">
            <div v-html="pageSummary"></div>
        </template>
        <template slot="main">
            <div class="ini-card">
                <div class="text-center" :class="{'d-none': dataReady}"><i
                        class="zmdi zmdi-refresh zmdi-hc-fw rotating text-gray home-loader"></i></div>
                <div :class="{'d-none': !dataReady}">
                    <main-form :mainFields="preparedFields"
                               :title="$t('LBL_PERSONNEL_CONSENTS_DATA')"
                               @submit="onFormSubmitted" ></main-form>
                </div>
            </div>
        </template>
        <template slot="custom">
            <div class="ini-card ini-card--sidebar">
                <custom-info :fields="mainFields" :settings="settings"></custom-info>
            </div>
        </template>
    </ini-layout>
</template>

<script>
    import IniLayout from '@/layout/Detail'
    import Layout from '@/layout/Boxed'
    import MainForm from '@/components/MainForm'
    import CustomInfo from '@/components/GDPR/Custom'

    export default {
        data() {
            return {
                mainFields: [],
                settings: [],
                exportLoader: false,
                forgetMeLoader: false,
                dataReady: false,
                hasAccess: false
            }
        },

        components: {
            'layout': Layout,
            'main-form': MainForm,
            IniLayout,
            CustomInfo
        },

        methods: {
            onFormSubmitted(data) {
                if (data.success) {
                    this.loadData()
                }
            },

            async loadData() {
                // Retrieves home page structure data
                var data = await Api.fetchStructure()
                if (!data.result) {
                    return;
                }

                var blocks = data.result.recordBlocks
                var fields = [];

                for (var i in blocks) {
                    var block = blocks[i];
                    if (!AppHelper.empty(block.fields)) {
                        fields = fields.concat(block.fields);
                    }
                }
                this.mainFields = fields
                this.settings = data.result.settings

                this.$store.commit('setUserInfo', data.result.user_info)
                this.$store.commit('setCompanyInfo', data.result.company_info)
            }
        },

        computed: {
            pageTitle() {
                return this.$t('LBL_GDPR_PAGE_TITLE')
            },

            pageSummary() {
                return this.settings.intoduction_message;
            },
            getSettings() {
                return {
                    currency: this.settings.currency_symbol, time: this.settings.hour_format,
                    date: this.settings.date_format, percentage: '%'
                };
            },

            preparedFields() {
                let preparedFields = [];
                for (let field of this.mainFields) {
                    if (['4', '70'].includes(field.uitype)) { // do not show contact no and created time
                        continue;
                    }
                    if (field.type === 'date') {
                        field.dateFormat = this.getSettings.date
                    }
                    if (field.type === 'time') {
                        field.time_24hr = this.getSettings.time !== '12'
                    }
                    if (field.type === "currency") {
                        field.params = this.getSettings.currency
                        field.rightAdded = this.getSettings.currency.replace(/&#\d+;/gm, function (s) {
                            return String.fromCharCode(s.match(/\d+/gm)[0]);
                        })
                    }
                    if (field.type === 'percentage') {
                        field.rightAdded = this.getSettings.percentage
                    }
                    if (field.type === "picture") {
                        field.isFloat = false
                        field.maxFiles = 1
                    }
                    if (field.type === "multipicklist") {
                      if (!Array.isArray(field.value)) {
                        field.value = field.value.split(' |##| ')
                      }
                    }


                    preparedFields.push(field)
                }
                return preparedFields
            }
        },

        beforeMount() {
            this.hasAccess = this.$store.getters.getStructure.access && this.$store.getters.getStructure.access.gdpr_portal
        },

        async mounted() {
            await this.loadData()
            this.dataReady = true
        }
    }
</script>
<style lang="scss">@import "@/assets/scss/pages/GDPR/_index.scss";</style>